import { useEffect, useState } from 'react';
import { Dialog, useMediaQuery } from '@mui/material';
import { Close } from '@mui/icons-material';
import eventBus from '../../../eventBus';
import CopyModalContent from './CopyModalContent';

const useStyles = () => ({
  container: {
    borderRadius: '10px',
    boxShadow: '0 5px 20px rgba(0, 0, 0, 0.07)',
    maxWidth: '600px',
    padding: {
      xxs: '48px 0px 0px',
      xs: '30px',
    },
  },
});

export default function CopyModal() {
  const classes = useStyles();
  const [modalType, setModalType] = useState('code');
  const [open, setOpen] = useState(false);
  const isXS = useMediaQuery((theme) => theme.breakpoints.down('xs'));

  function handleClose() {
    setOpen(false);
  }

  useEffect(() => {
    eventBus.on('openCopyModal', (data) => {
      setOpen(true);
      setModalType(data?.modalType || 'code');
    });
    return () => {
      eventBus.remove('openCopyModal');
    };
  }, []);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      fullScreen={isXS}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: classes.container,
      }}
    >
      <Close
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: '12px',
          top: '12px',
          color: '#4D586F',
          cursor: 'pointer',
        }}
      />
      <CopyModalContent modalType={modalType} />
    </Dialog>
  );
}
